import styled from 'styled-components';

export const EditProcessFormWrapper = styled.div`
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    margin-top: 24px;
  }

  .task-lightYellow {
    background: ${({ theme }) => theme.colors.tone.lightYellow};
  }

  .task-lightGreen {
    background: ${({ theme }) => theme.colors.tone.lightGreen};
  }

  .task-lightRed {
    background: ${({ theme }) => theme.colors.tone.lightRed};
  }
`;
